import { Component } from '@angular/core';

@Component({
  selector: 'app-pssr-create',
  templateUrl: './pssr-create.component.html',
  styleUrls: ['./pssr-create.component.scss']
})
export class PssrCreateComponent {
}
